import React, { useContext, useEffect } from 'react';
import { OrganizationsContext } from '../OrganizationContextProvider';
import { useParams, useLocation, generatePath } from 'react-router-dom';
import { useNavigate } from 'src/utils/useNavigate';
import Button from 'src/components/Button';
import Text from 'src/components/Text';
import Link from 'src/components/Link';
import classnames from 'classnames';
import routes from 'src/constants/routes';
import styles from './styles.module.scss';

const OrganizationsList: React.FC = () => {
  const params = useParams();
  const { search } = useLocation();
  const { organizations } = useContext(OrganizationsContext);
  const routerNavigate = useNavigate();
  /* При навигации через Link на странице добавления организации не проходит проверка
        cades plugin и отображается ссылка для установки плагина. Если страницу
        перезагрузить, то проверка проходит и можно перейти к выбору сертификата.
        Причина не ясна. На Портале поведение аналогично и тоже используется внешняя ссылка. */
  const browserNavigate = useNavigate({ browserNavigation: true });
  
  useEffect(() => {
    // необходимо сразу отображать первую организацию в агенте
    if (!params.organizationUeid && organizations && organizations.length > 0) {
      const pathname = generatePath(routes.organization, { organizationUeid: organizations[0].organizationUeid });
      routerNavigate({ pathname, search });
    }
  }, [organizations]);
  
  const handleAddOrganizationClick = () => {
    browserNavigate(routes.addOrganization);
  }

  return (
    <div>
      <Text type="h3" className={styles['title']}>Организации</Text>
      <div className={styles['list']}>
        {organizations.map(
          ({
            name,
            inn,
            ogrn,
            organizationUeid,
          }: {
            name: any;
            inn: any;
            ogrn: any;
            organizationUeid: any;
          }) => {
            const isSelected = params.organizationUeid === organizationUeid;
            const organizationClassNames = classnames(styles['organization'], {
              [styles['selected-organization']]: isSelected,
            });
            const pathname = generatePath(routes.organization, { organizationUeid });
            return (
              <Link
                key={organizationUeid}
                to={{ pathname, search }}
                className={organizationClassNames}
              >
                <Text type="p">{name}</Text>
                <Text type="span" muted>ИНН {inn}</Text>
                <br/>
                <Text type="span" muted>ОГРН {ogrn}</Text>
              </Link>
            );
          }
        )}
        <div className={styles['add-organization-wrapper']}>
          <Button variant="outlined" width="available" onClick={handleAddOrganizationClick}>
            Добавить организацию
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OrganizationsList;
